// extracted by mini-css-extract-plugin
export default {"MainButton":"MainButton_MainButton__Fpxmo","Shimiring":"MainButton_Shimiring__fF8QL"};